const LINKS = [
  {
    title: "Matches",
    icon: "calendar",
    pages: [
      {
        title: "Meine Matches",
        path: "/matches", // Placeholder link
      }
    ],
  },
  {
    title: "Office Bereich",
    icon: "envelope",
    pages: [
      {
        title: "Finanzen",
        path: "/office/finanzen", // Placeholder link
      },
      {
        title: "Ligaordnung",
        path: "https://oekfb.eu/ligaordnung", // Placeholder link
      },
    ],
  }
];

export default LINKS;
